// English, number, -, _
const username = /^[A-Za-z0-9\-_]*$/;

export default username;
